export enum EntityStoreKey {
  languageConfig = 'languageConfig',
  languageTranslations = 'languageTranslations',
  possibleLanguages = 'possibleLanguages',
  languageList = 'languageList',
}
